module.exports = __webpack_public_path__ + "static/media/mirror-example-3.e8c68419.png";